import { data } from "dcmjs";
import dicomParser from "dicom-parser";
import { Buffer } from "buffer";
import { retrieveInstance } from "lib/client/dicomweb";

export function createDicomBlob(bufferOrDataset: data.NaturalizedDataset) {
  let blob: Blob;
  if (bufferOrDataset instanceof ArrayBuffer) {
    blob = new Blob([bufferOrDataset], { type: "application/dicom" });
  } else {
    if (!bufferOrDataset._meta) {
      throw new Error("Dataset must have a _meta property");
    }
    var buffer = Buffer.from(data.datasetToDict(bufferOrDataset).write());
    blob = new Blob([buffer], { type: "application/dicom" });
  }
  return blob;
}

export async function createPDFBlobFromDicomMetadata(
  pdfInstance: data.NaturalizedDataset
) {
  const arrayBuffer = await retrieveInstance(
    pdfInstance.StudyInstanceUID,
    pdfInstance.SeriesInstanceUID,
    pdfInstance.SOPInstanceUID
  );
  const dataset = dicomParser.parseDicom(new Uint8Array(arrayBuffer));
  const fileTag = dataset.elements.x00420011;
  const offset = fileTag.dataOffset;
  const remainder = offset + fileTag.length;
  const pdfByteArray = dataset.byteArray.slice(offset, remainder);
  const pdfBlob = new Blob([pdfByteArray], { type: "application/pdf" });
  return pdfBlob;
}

// TODO : Mutualize code with Report.tsx viewOrDownloadPDF function
export function downloadData(data: Blob | string, filename: string) {
  const link = document.createElement("a");
  if (data instanceof Blob) {
    const objectURL = window.URL.createObjectURL(data);
    link.href = objectURL;
    // For Firefox it is necessary to delay revoking the ObjectURL
    setTimeout(function () {
      window.URL.revokeObjectURL(objectURL);
    }, 100);
  } else {
    link.href = data;
  }
  link.download = filename;
  link.click();
}
